import { _defineProperty } from "@slyte/core/src/lyte-utils";
import {Route} from "../../../node_modules/@slyte/router/index.js";
let BreadcrumbComp;

class Breadcrumb extends Route {
    render() {
        return { outlet: '#zcatcomponent', component: BreadcrumbComp };
    }

    static actions(arg1) {
        return Object.assign(super.actions({

        }), arg1);
    }

    _() {
        _;
    }

    getRequirements() {
        arguments[1].push(import(
            /* webpackChunkName: "components/javascript/zcat-components/breadcrumb-comp" */
            "../../../components/javascript/zcat-components/breadcrumb-comp"
        ).then(function(res) {
            BreadcrumbComp = res.BreadcrumbComp;
        }));

        
;
    }
}

export {Breadcrumb};

